import React from 'react';
import { FormattedMessage } from '../../../../../../taboola-common-frontend-modules/i18n';
import TooltipSection from '../../TooltipSection';

const ThirdPartyTrackingTooltip = () => (
    <TooltipSection
        tip={
            <FormattedMessage
                id="campaign.editor.duplicateCampaignSettings.ads.tooltip.tip"
                defaultMessage="select this option only if you plan to use the same (or very similar) ads in your new campaign."
            />
        }
    >
        <FormattedMessage
            id="campaign.editor.duplicateCampaignSettings.trackingAndThirdPartyTags.tooltip.main"
            defaultMessage="Duplicate the original campaign and ads' tracking code and 3rd party tags."
        />
    </TooltipSection>
);

export default ThirdPartyTrackingTooltip;
